module.exports = {
  // JCRing成员页 西班牙语言包
  JCRing_member: {
    index1: "Salud de los miembros",
    index2: "Grupos de salud",
    index3: "Miembros",
    index4: "Añadir grupo",
    index5: "Grupos unidos",
    index6: "Configuración de alertas",
    index7: "Permita que quienes se preocupan por su salud se preocupen más por usted a distancia, con cuidado oportuno",
    index8: "Aún no ha unido a ningún grupo",
    index9: "Centro de mensajes",
    index10: "Invitar a unirse a través de / teléfono / correo electrónico / código QR / WeChat",
    
    
    addgroup1: "Nombre del grupo",
    addgroup2: "Tipo de grupo",
    addgroup3: "Por favor, ingrese el nombre del grupo",
    addgroup4: "Grupo familiar",
    addgroup5: "Grupo de empresa",
    addgroup6: "Otro grupo",
    addgroup7: "Grupo médico",
    addgroup8: "Grupo escolar",
    addgroup9: "Confirmar",
    addgroup10: "Cancelar",
    addgroup11: "Crear ahora",
    addgroup12: "El nombre del grupo ya existe",
    
    
    memberlist1: "Lista de miembros",
    memberlist2: "Tiene",
    memberlist3: "Excepciones",
    memberlist4: "Normal",
    memberlist5: "Añadir miembro",
    memberlist6: "Disolver",
    memberlist7: "Sin miembros",
    memberlist8: "Cargando...",
    memberlist9: "¿Disolver este grupo?",
    memberlist10: "Disuelto con éxito",
    memberlist11: "Guardado con éxito",
    memberlist12: "Modificar información del grupo",
    memberlist13: "Disolver grupo",
    memberlist14: "Visión general de la salud",
    memberlist15: "Elementos normales",
    memberlist16: "Elementos anómalos",
    memberlist17: "Haga clic para ver",
    memberlist18: "Sin datos de ayer",
    memberlist19: "Ayer",
    memberlist20: "Enviado",
    memberlist21: "Invitaciones al grupo enviadas, pendiente de confirmación",
    
    
    updatemember1: "Foto de perfil",
    updatemember2: "Cambiar",
    updatemember3: "Apodo original",
    updatemember4: "Modificar apodo",
    
    
    healthdata1: "datos de salud",
    healthdata2: "datos de salud",
    healthdata3: "Domingo",
    healthdata4: "Lunes",
    healthdata5: "Martes",
    healthdata6: "Miércoles",
    healthdata7: "Jueves",
    healthdata8: "Viernes",
    healthdata9: "Sábado",
    healthdata10: "Frecuencia cardíaca",
    healthdata11: "Variabilidad de la frecuencia cardíaca",
    healthdata12: "Presión sistólica",
    healthdata13: "Presión diastólica",
    healthdata14: "Variabilidad de la temperatura",
    healthdata15: "Saturación de oxígeno en sangre",
    healthdata16: "Sueño",
    healthdata17: "Estrés",
    healthdata18: "Colesterol",
    healthdata19: "Triglicéridos",
    healthdata20: "Colesterol LDL",
    healthdata21: "Colesterol HDL",
    healthdata22: "Glucosa en sangre",
    healthdata23: "Antes de las comidas",
    healthdata24: "Después de las comidas",
    healthdata25: "Consumo máximo de oxígeno",
    healthdata26: "Respiración",
    healthdata27: "Pasos",
    healthdata28: "Paso",
    healthdata29: "Calorías",
    healthdata30: "kcal",
    healthdata31: "Distancia",
    healthdata32: "Kilómetros",
    healthdata33: "Ritmo",
    healthdata35: "Segundos/km",
    healthdata36: "Minutos",
    healthdata37: "Cargando datos de salud",
    healthdata38: "Datos de ejercicio",
    healthdata39: "Alertas",
    healthdata40: "No autorizado",
    healthdata41: "Modificar información del miembro",
    healthdata42: "Eliminar miembro",
    healthdata43: "Correo electrónico:",
    healthdata44: "Teléfono:",
    healthdata45: "¿Eliminar a este miembro?",
    healthdata46: "Las fechas futuras no se pueden mostrar",
    healthdata47: "Hoy",
    
    
    
    addmember1: "Invitar miembros",
    addmember2: "Agregar cuenta de miembro",
    addmember4: "Usando 'Cuentas de miembros', puedes ver los datos de salud de los miembros y establecer rangos de datos de alerta para un mejor monitoreo de su salud",
    addmember5: "Más información",
    addmember6: "Miembros del grupo de salud",
    addmember7: "Invitar",
    addmember8: "Unirse",
    addmember9: "Invitar escaneando el código QR",
    addmember10: "Invitación por WeChat",
    addmember11: "Invitar a unirse al grupo escaneando el código QR",
    addmember12: "Invitar a unirse al grupo a través de WeChat",
    addmember13: "Invitación por teléfono/correo electrónico",
    addmember14: "Invitar a unirse al grupo por teléfono/correo electrónico",
    addmember15: "Invita a los miembros a unirse para ver su estado de salud",
    addmember16: "Enviar invitación",
    addmember17: "Enviado",
    addmember18: "Pendiente de confirmación",
    addmember19: "Ya he unido",
    addmember20: "Compartir ahora",
    addmember21: "Guardar imagen",
    addmember22: "He rechazado",
    addmember23: "He salido",
    addmember24: "El miembro ha salido",
    addmember25: "El miembro ha rechazado",
    addmember26: "El miembro se ha unido",
    addmember27: "Otros métodos de adición",
    
    
    code1: "Código QR del grupo",
    code2: "Grupo de gestión de salud",
    code3: "Este código QR es válido por 5 minutos. Por favor, úselo pronto.",
    
    
    invide1: "Invitación al grupo",
    invide2: "Salud de los miembros",
    invide3: "Te invita a unirte al grupo...",
    invide4: "Unirse a este grupo",
    invide5: "Para la seguridad de tus datos, se recomienda revisar la información del grupo antes de unirte.",
    invide6: "Después de unirte al grupo, autorizarás a los seguidores a ver tus datos de salud.",
    
    
    sethealthdata1: "Configuración de datos de salud",
    sethealthdata2: "Confirmar",
    sethealthdata3: "Por favor, configura un apodo",
    sethealthdata4: "Permitir todo",
    sethealthdata5: "Configura un apodo",
    sethealthdata6: "Guardar",
    sethealthdata7: "Por favor, ingresa",
    sethealthdata8: "Por favor, sube en formato de imagen",
    sethealthdata9: "Por favor, configura tanto el apodo como el avatar",
    sethealthdata10: "Por favor, configura un avatar",
    sethealthdata11: "La longitud del apodo debe ser de 1 a 8 caracteres",
    
    
    setscope1: "Rango de frecuencia cardíaca",
    setscope2: "Rango de temperatura",
    setscope3: "Rango de sueño",
    setscope4: "Rango de frecuencia cardíaca fetal",
    setscope5: "Glucosa en sangre antes de las comidas",
    setscope6: "Glucosa en sangre después de las comidas",
    setscope7: "Rango de oxígeno en sangre",
    setscope8: "Ácido úrico masculino",
    setscope9: "Ácido úrico femenino",
    setscope10: "Presión sistólica",
    setscope11: "Presión diastólica",
    setscope12: "Límite superior",
    setscope13: "Límite inferior",
    setscope14: "Configuración de alertas",
    setscope15: "Configuración guardada",
    setscope16: "Límite superior",
    setscope17: "Límite inferior",
    setscope18: "Alerta",
    
    
    onload1: "Haga clic",
    onload2: "Unirse al grupo de salud",
    onload3: "Por favor, abra en el navegador",
    onload4: "Entendido",
    onload5: "Youhong Salud, Salud inteligente cada día",
    onload6: "Descargar gratis desde App Store",
    onload7: "Descargar gratis",
    onload8: "Enlace expirado",
    onload9: "Código QR expirado",
    onload10: "Unido con éxito",
    
    
    // invide1: "Invitación al grupo",
    // invide2: "Salud de los miembros",
    // invide3: "Te invita a unirte al grupo...",
    // invide4: "Unirse a este grupo",
    // invide5: "Para la seguridad de tus datos, se recomienda revisar la información del grupo antes de unirte.",
    // invide6: "Después de unirte al grupo, autorizarás a los seguidores a ver tus datos de salud.",
    
    
    guide1: "Después de ingresar a la salud de los miembros, debe crear primero el tipo de grupo correspondiente.",
    guide2: "Después de crear el grupo, ingrese al grupo para ver el resumen de salud de los usuarios e invitar a nuevos miembros.",
    guide3: "Para invitar a nuevos miembros al grupo, puede usar métodos como escanear un código QR, WeChat, número de teléfono/correo electrónico. Después de que los nuevos miembros se unan al grupo, puede ver sus actualizaciones diarias de salud.",
    guide4: "Haga clic para ver el resumen de salud, donde puede ver los datos de salud de los miembros y determinar las condiciones normales o anormales.",
    guide5: "Siguiente",
    guide6: "Finalizar",
    guide7: "Supera el valor de advertencia",
    
    invite1: "Invitar por número de teléfono/correo electrónico",
    invite2: "Por favor ingrese la cuenta",
    invite3: "Por favor ingrese el número de teléfono",
    invite4: "Por favor ingrese el correo electrónico",
    invite5: "Por favor ingrese un número de teléfono válido",
    invite6: "Por favor ingrese un correo electrónico válido",
    invite7: "Ya se unió a este grupo",
    invite8: "El usuario no existe",
    invite9: "Seleccione país o región",
    invite10: "Por favor ingrese palabras clave de búsqueda",
    invite11: "Confirmar usuario",
    invite12: "Invitarlo",
    invite13: "Por favor seleccione",
  },

  // AI H5页面
  JCRingAI: {
    index: "Hola,",
    index1: "Aquí están tus perspectivas semanales de salud.",
    index2: "Semana",
    index3: "Mes",
    index4: "Índice de salud",
    index5: "Índice de sueño",
    index6: "Índice de vitalidad",
    index7: "Índice de equilibrio",
    index8: "Día",
    index9: "Año",
    index10: 'Perspectivas Semanales',
    index11: 'Perspectivas Mensuales',
    index12: "Aquí están tus perspectivas mensuales de salud.",
 
    sleep: 'Recuperación del sueño',
    sleep1: 'Tendencia del índice de sueño',
    sleep2: 'Tendencia del índice de sueño',
    sleep3: 'El índice de sueño es un indicador para evaluar su salud del sueño, calculado en función de varias métricas como la duración total del sueño, la eficiencia del sueño, el tiempo para quedarse dormido, la frecuencia cardíaca durante el sueño, los niveles de oxígeno del sueño y la variabilidad de la frecuencia cardíaca (HRV), etc.',
    sleep4: 'Su índice de sueño es',
    sleep5: 'Resumen del sueño',
    sleep6: 'La duración media del sueño es',
    sleep7: 'Etapas del sueño',
    sleep8: 'Duración media',
    sleep9: 'Porcentaje medio',

    sleep11: 'Siestas',
    sleep12: 'Despierto',
    sleep13: 'REM',
    sleep14: 'Sueño ligero',
    sleep15: 'Sueño profundo',
    sleep16: 'Ocupando % de toda la semana',
    sleep17: 'La duración total del sueño es',
    sleep18: 'La eficiencia promedio del sueño es',
    sleep19: '%, El tiempo promedio para dormirse es',
    sleep20: 'min',
    sleep21: 'Información sobre el sueño',

    sleep22: 'Datos mejorados del sueño',
    sleep23: 'Índice de sueño',
    sleep24: 'Comparado con la semana pasada',
    sleep25: 'El índice de sueño promedio mensual es',
    sleep26: 'Duración del sueño',
    sleep27: 'Tiempo para quedarse dormido',
    sleep28: 'Tiempo promedio mensual para quedarse dormido',
    sleep29: 'Áreas a mejorar',
    sleep30: 'Eficiencia del sueño',
    sleep31: 'La eficiencia del sueño mensual es',
    sleep32: '¿Cómo mejorar la eficiencia del sueño?',
    sleep33: 'Perspectivas mensuales del sueño',

    Expend: 'Actividad',
    Expend1: 'Tendencia del índice de actividad',
    Expend2: 'Tendencia del índice de actividad',
    Expend3: 'El índice de actividad es un indicador para evaluar tu estado de ejercicio, calculado en base a varias métricas como pasos diarios, distancia, calorías y volumen de ejercicio.',
    Expend4: 'El índice promedio de actividad semanal es',
    Expend5: 'Resumen de la actividad',
    Expend6: 'Los pasos promedio son',
    Expend7: ', la distancia media es',
     Expend8: 'km, calorías son',
    Expend9: ' kcal',
    Expend10: 'Tipo/Fecha',
    Expend11: 'Pasos',
    Expend12: 'Kcal',
    Expend13: 'Distancia',
    Expend14: 'Tienes 5 días para completar el objetivo de pasos',
    Expend15: ', tienes 5 días para completar el objetivo de calorías',
    Expend16: ', tienes 5 días para completar el objetivo de distancia',
    Expend17: 'Información sobre la actividad',
    Expend18: 'Índice de actividad',
    Expend19: 'El índice de actividad promedio mensual es',
    Expend20: 'Número promedio de pasos',
    Expend21: 'El promedio mensual de pasos es',
    Expend22: 'Calorías promedio',
    Expend23: 'El promedio mensual de calorías es',
    Expend24: 'kcal',
    Expend25: 'Distancia promedio',
    Expend26: 'El promedio mensual de distancia es',
    Expend27: 'km',
    Expend28: 'Cómo mejorar los datos de actividad?',
    Expend29: 'Información sobre la actividad',

    Pressure: 'Equilibrio',
    Pressure1: 'Tendencia del índice de equilibrio',
    Pressure2: 'Tendencia del índice de equilibrio',
    Pressure3: 'El índice de equilibrio es un indicador para evaluar tu estado de estrés, calculado en base a varios parámetros como el estrés diario, HRV, la respuesta al estrés y el índice de recuperación.',
    Pressure4: 'El índice promedio de vitalidad es',
    Pressure5: 'El índice de equilibrio se mantiene generalmente estable, pero con fluctuaciones significativas, lo que puede estar relacionado con tu estado emocional. Se recomienda aprender técnicas de manejo del estrés, como la meditación y la respiración profunda, para regular las emociones y mantener la salud física y mental.',
    Pressure6: 'Resumen del equilibrio',
    Pressure7: 'El estrés medio es',
    Pressure8: 'La reacción al estrés media es',
    Pressure9: 'El índice medio de recuperación es',
    Pressure10: 'Estrés',
    Pressure11: 'Reacción al estrés',
    Pressure12: 'Índice de recuperación',
    Pressure13: 'Perspectivas del equilibrio',
    Pressure14: 'Tus datos de equilibrio mejorados',
    Pressure15: 'Índice de equilibrio',
    Pressure16: 'La reacción mensual al estrés es',
    Pressure17: 'Estrés medio',
    Pressure18: 'El estrés promedio mensual es',
    Pressure19: '¿Cómo aliviar el estrés?',
    Pressure20: 'Perspectivas sobre el equilibrio y la recuperación?',
    
    
    
    Health: 'Salud cardiovascular',
    Health1: 'Tu tendencia semanal de la frecuencia cardíaca',
    Health2: 'La frecuencia cardíaca media es',
    Health3: 'bpm',
    Health4: 'Tu tendencia semanal de oxígeno en sangre',
    Health5: 'El promedio semanal de oxígeno en sangre es',
    Health6: 'Tu riesgo semanal de diabetes',
    Health7: 'Evaluación semanal del riesgo de diabetes',
    Health8: 'Días',
    Health9: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],

    Health10: 'Tus datos normales de salud',
    Health11: 'Frecuencia cardíaca media',
    Health12: 'La frecuencia cardíaca media mensual es',
    Health13: 'Saturación media de SpO2',
    Health14: 'La saturación media mensual de SpO2 es',
    Health15: 'Tus datos anormales de salud',
    Health16: 'Variabilidad media de la frecuencia cardíaca',
    Health17: 'La variabilidad media mensual de la frecuencia cardíaca es',
    Health18: 'ms',
    Health19: 'Cómo mejorar la HRV?',
        

    
    


    // 新增文字
    index14: "Informe de tendencias de datos anuales",
    sleep34: "Cómo mejorar",
    sleep35: "Informe anual del sueño",
    sleep36: "Índice de sueño promedio anual",
    sleep37: "Eficiencia del sueño anual",
    sleep38: "Tiempo promedio anual para conciliar el sueño",
    Expend30: "Informe de vitalidad anual",
    Expend31: "Índice de vitalidad promedio anual",
    Expend32: "Número promedio anual de pasos",
    Expend33: "Calorías promedio anuales",
    Expend34: "Distancia promedio anual",
    Expend35: "Índice de vitalidad promedio anual",
    Pressure21: "Informe anual de estrés y equilibrio",
    Pressure22: "Respuesta de emergencia anual",
    Pressure23: "Índice de recuperación anual",
    Pressure24: "Índice de recuperación mensual",
    Pressure25: "Estrés promedio anual",
    Health20: "Informe de datos de salud",
    Health21: "HRV promedio anual",
    Health22: "Oxígeno en sangre promedio anual",
    Health23: "Frecuencia cardíaca promedio anual",
    Record9: "Solo se utilizan las semanas con más de 3 días para la evaluación de datos",
    Record10: "Solo se utilizan las semanas con más de 3 días este mes para la evaluación de datos",
    Record11: "Solo se utilizan las temporadas con más de 2 temporadas este año para la evaluación de datos",
    
 }
};



// WEBPACK FOOTER //
// ./src/lang/es.js